import { default as Select } from 'antd/es/select';
import { default as Space } from 'antd/es/space';
import { useMemo } from 'react';

import { convertFieldToHumanReadable } from 'utils/formatters/fieldToDisplayableName';

import { TertiaryButton } from '@atoms/buttons/TertiaryButton';

import { LocalDateRangeWrapper } from '@molecules/LocalDateRangeWrapper';

import {
  ACCOUNT_TRANSACTION_ENTRY_TYPES,
  ACCOUNT_TRANSACTIONS_ENTRY_TYPE_FILTER_TEST_ID
} from './constants';
import type { FiltersState } from './localState';

const { Option } = Select;

type Props = {
  filters: FiltersState;
  setFilters: (filters: FiltersState) => void;
  resetState: () => void;
};

export const AccountTransactionsFilters = ({
  filters,
  setFilters,
  resetState
}: Props) => {
  const hasFilters = useMemo(() => {
    return Object.values(filters).some(
      (value) => Boolean(value) && value !== 'All'
    );
  }, [filters]);

  return (
    <div className="flex items-center">
      <Space wrap size="small">
        <LocalDateRangeWrapper />

        {/* Entry type */}
        <Select<FiltersState['entry_type']>
          data-testid={ACCOUNT_TRANSACTIONS_ENTRY_TYPE_FILTER_TEST_ID}
          className="mini-cool-shadow w-40"
          showSearch
          value={filters.entry_type}
          popupMatchSelectWidth={false}
          defaultValue="All"
          onChange={(value) => {
            setFilters({
              entry_type: value
            });
          }}
        >
          <Option key="All">All Types</Option>
          {ACCOUNT_TRANSACTION_ENTRY_TYPES.map((option) => (
            <Option key={option} value={option}>
              {convertFieldToHumanReadable(option)}
            </Option>
          ))}
        </Select>

        {hasFilters && (
          <TertiaryButton className="h-10 font-semibold" onClick={resetState}>
            Clear filters
          </TertiaryButton>
        )}
      </Space>
    </div>
  );
};
